import type { SfConfirm } from '@app/types'
import type { CopyPreviousLedgerDataParameters } from '@app/shared/types/sf-data'

import { askUnreviewConfirmation } from '@app/shared/services/data-alteration-guard'
import SFetch from '@app/utils/sfetch'
import { SfLog } from '@app/adapters/logger'

export async function copyPreviousLedgerData(
  parameters: CopyPreviousLedgerDataParameters
): Promise<void> {
  let response

  try {
    response = (await SFetch.json(parameters.confirmActionPath)) as {
      hasData: boolean
    }
  } catch (error) {
    SfLog.warn('Request failed', {
      extra: {
        error: error,
      },
    })
    return
  }

  if (response.hasData) {
    const sfConfirm = window.sfConfirm as SfConfirm<() => void>

    sfConfirm({
      question: window.I18n.t(
        'assistant_check.platform.copy_previous_ledger_data.overwrite_warning',
        {
          period: parameters.currentPeriodName,
        }
      ),
      confirmLabel: window.I18n.t(
        'assistant_check.platform.copy_previous_ledger_data.overwrite'
      ),
      cancelLabel: window.I18n.t('common.form.cancel'),
      onConfirm: function () {
        void copyPreviousLedgerDataWithUnreviewConfirmation(parameters)
      },
    })
  } else {
    void copyPreviousLedgerDataWithUnreviewConfirmation(parameters)
  }
}

async function copyPreviousLedgerDataWithUnreviewConfirmation(
  parameters: CopyPreviousLedgerDataParameters
): Promise<void> {
  const { confirmed } = await askUnreviewConfirmation()
  if (!confirmed) return

  performCopyPreviousLedgerData(parameters)
}

function performCopyPreviousLedgerData(
  parameters: CopyPreviousLedgerDataParameters
): void {
  try {
    SFetch.postFormRedirect({
      url: parameters.actionPath,
      method: 'post',
      authenticityToken: window.Silverfin.csrfToken(),
      data: [],
    })
  } catch (error) {
    SfLog.error('Request failed', {
      extra: {
        error: error,
      },
    })
  }
}
